import CloseButton from "@/CloseButton";
import { useContext, useState } from 'react';
import ShopContext from "^/ShopContext";
import FilterListItem from "./FilterListItem";
import BrandFilter from "./BrandFilter";
const FilterBlock = (props) => {

  const {
    value = 'Brooking Industries',
    category_name = 'Brand',
    list = []
  } = props;

  const [seeMore, setSeeMore] = useState(false);

  const {
    selectedFilter,
    filterCounts,

  } = useContext(ShopContext);



  if (/please note/i.test(category_name)) {
    return <></>
  }
  const refinedList = seeMore ? list : list.slice(0, 4);
  let parsedList = /brand/i.test(category_name)
    ?
    refinedList.map(each =>
      <BrandFilter
        key={each.id}
        each={each}
      />)

    :
    refinedList.map(each =>
      <FilterListItem
        filterCounts={filterCounts}
        name={category_name}
        description={each}
        key={each}
      />
    )


  return (
    <div className="accordion-block ss-facet-container ss-facet-container-list" id="ss-brand">
      <div class="accordion-navigation toggleLink is-open" >
        <h5 class="accordion-title side-module-heading">
          <span class="">{category_name.toLowerCase()}</span>
        </h5>
        <div class="accordion-navigation-actions">
          <i class="fa fa-chevron-down accordion-indicator toggleLink-text toggleLink-text--on ng-scope"></i>
        </div>
      </div>
      <div class="accordion-content is-open">
        <ul class="navList" >
          {parsedList}
        </ul>
      </div>
      {
        list.length > 4 ?
          <a className='ss-list-link'
            style={{ marginLeft: 24, display: 'block', paddingBottom: 12 }}
            onClick={() => setSeeMore(prev => !prev)}
          >{seeMore ? '-' : '+'} Show {seeMore ? 'Less' : 'More'}</a>

          : null
      }
    </div>
  )
}
export default FilterBlock;